export default "__VITE_ASSET__DKmKRl5u__"